import { CompanyEnrichAutoCompleteItem } from "@/pages/Private/pages/CompanyEnrich/components/CompanyEnrichAutoComplete";

type FetchCountries = (query: string) => Promise<CompanyEnrichAutoCompleteItem[]>;

/**
 * Turns the free-text ICP location ("Germany", "Germany and Austria") into the
 * countries the Track pane's location picker shows, one lookup per part.
 *
 * A part that names no country — a region like "DACH", a city, a vague area —
 * is dropped: the pane then starts with no location filter and the user picks
 * one, which is better than guessing at an expansion. The ICP location still
 * reaches the search through the seeded semantic query.
 */
export const resolveIcpCountries = async (
	location: string | null | undefined,
	fetchCountries: FetchCountries
): Promise<CompanyEnrichAutoCompleteItem[]> => {
	const parts = (location ?? "")
		.split(/[,/&]|\band\b|\bund\b/i)
		.map((part) => part.trim())
		.filter((part) => part.length >= 2);

	if (parts.length === 0) {
		return [];
	}

	const matches = await Promise.all(
		parts.map(async (part) => {
			try {
				const [first] = await fetchCountries(part);

				return first?.title.toLowerCase().startsWith(part.toLowerCase()) ? first : null;
			} catch (err) {
				console.error(err);

				return null;
			}
		})
	);

	const byCode = new Map(matches.filter(Boolean).map((item) => [item!.id, item!]));

	return [...byCode.values()];
};
